import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { TaxesUndeclaredModel } from "@modules/taxes/domain/entities/taxes.model";
import { Observable } from "rxjs";
import { Dictionary } from "@helpers/types";

export interface TaxesMultiDeclarationState {
	hasError: boolean;
	isLoading: boolean;
	trxDictionary: Dictionary<TaxesUndeclaredModel[]>;
}

const initialState: TaxesMultiDeclarationState = {
	hasError: false,
	isLoading: true,
	trxDictionary: {}
};

@Injectable()
export class TaxesMultiDeclarationStateService extends StateService<TaxesMultiDeclarationState> {
	public isLoading$ = this.select((state) => state.isLoading);
	public hasError$ = this.select((state) => state.hasError);
	public trxDictionary$ = this.select((state) => state.trxDictionary);

	public constructor() {
		super(initialState);
	}

	public getState$(): Observable<TaxesMultiDeclarationState> {
		return this.select((state) => state);
	}

	public updateState(model: Partial<TaxesMultiDeclarationState>): void {
		this.setState(model);
	}

	public hasError(): boolean {
		return this.state?.hasError;
	}

	public taxesMultiErrorState(): void {
		this.updateState({
			hasError: true,
			isLoading: false,
			trxDictionary: {}
		});
	}

	public setIsLoading(isLoading: boolean): void {
		this.setState({
			isLoading: isLoading
		});
	}
}
